import * as React from 'react';
import { Paragraph2 } from '@cian/ui-kit';
import { Link } from '../Link';
import { ReliableZhkIcon } from '../Reliability/ReliabilityIcons';

import * as styles from './ReliableBlock.css';

interface IReliableBlockProps {
  text: string;
  onClick(event: React.MouseEvent<HTMLElement>): void;
}

export function ReliableBlock({ text, onClick }: IReliableBlockProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['icon']}>
        <ReliableZhkIcon />
      </div>
      <div>
        <Paragraph2>{text}</Paragraph2>
        <Link url={'#reliable'} onClick={onClick}>
          Узнать больше
        </Link>
      </div>
    </div>
  );
}
